const $ = require("jquery");
require("slick-carousel");

/**
 * Reviews carousel for the shared reviews block.
 * Markup: templates/public/static/components/partials/reviews-block--embed.html.twig
 *
 * Require this from a page JS entry:
 *   require("../../components/ui-components/reviewsCarousel");
 * It self-initialises on DOM ready and does nothing when the block is absent,
 * so it is safe to require from an entry shared by several pages.
 *
 * The prev/next labels are read from the markup so they stay translated.
 */
function initReviewsCarousel() {
    const $slider = $(".reviews-block__slider");
    if (!$slider.length) {
        return;
    }

    const $nav = $(".reviews-block__nav");
    const prevLabel = $nav.data("prev-label") || "Previous";
    const nextLabel = $nav.data("next-label") || "Next";
    const arrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

    // slick's infinite mode clones the first/last `slidesToShow` slides so
    // the loop has no visible seam. Those clones are new DOM nodes created
    // after LazyLoad.js's IntersectionObserver already scanned the page, so
    // any data-lazy-src / data-lazy-background inside a clone (e.g. the
    // video review card's poster) never resolves and the card renders
    // blank once scrolled into view. Slick rebuilds its clones on init and
    // on every responsive breakpoint change, so resolve both eagerly
    // instead of waiting on an observer that will never see them.
    function resolveClonedLazyMedia() {
        $slider.find(".slick-cloned [data-lazy-src], .slick-cloned [data-lazy-background]").each(function () {
            const $el = $(this);
            const lazySrc = $el.data("lazy-src");
            const lazyBg = $el.data("lazy-background");

            if (lazySrc && !$el.attr("src")) {
                $el.attr("src", lazySrc);
            }

            if (lazyBg) {
                $el.css("background-image", "url(" + lazyBg + ")");
            }
        });
    }

    $slider.on("init breakpoint", resolveClonedLazyMedia);

    $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        speed: 300,
        dots: false,
        arrows: true,
        appendArrows: $nav.length ? $nav : $slider,
        prevArrow: '<button type="button" class="reviews-block__arrow reviews-block__arrow--prev" aria-label="' + prevLabel + '">' + arrowSvg + '</button>',
        nextArrow: '<button type="button" class="reviews-block__arrow reviews-block__arrow--next" aria-label="' + nextLabel + '">' + arrowSvg + '</button>',
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    });
}

$(function () {
    initReviewsCarousel();
});

module.exports = { initReviewsCarousel };
